import PropTypes from 'prop-types';
import React from 'react';

import { Color, colorList, ComponentSize } from '../../../typings/design-tokens';
import { IComponent } from '../../../typings/generic-component';
import styles from '../../../utils/styles';

import './logo.scss';

export const logoSizeList: ComponentSize[] = ['small', 'medium'];

export type VerticalAlign = 'top' | 'middle' | 'bottom';
export const verticalAlignList: VerticalAlign[] = ['top', 'middle', 'bottom'];

export interface ILogo extends IComponent {
  svg?: Function;
  reverse?: Boolean;
  verticalAlign?: VerticalAlign;
}

const sizes = Object.freeze({
  small: 20,
  medium: 26,
});

const Logo: React.FC<ILogo> = ({
  color = 'inherit',
  size = 'small',
  svg = () => {},
  reverse = false,
  verticalAlign,
}) => {
  const className = styles(
    `logo logo--c-${color} logo--${size}`,
    verticalAlign && `logo--align-${verticalAlign}`,
    reverse && 'logo--reverse'
  );

  return (
    <i className={className}>
      {svg({
        height: sizes[size],
      })}
    </i>
  );
};

/* istanbul ignore else */ if (process.env.NODE_ENV !== 'production') {
  Logo.propTypes = {
    color: PropTypes.oneOf<Color>(colorList),
    reverse: PropTypes.bool,
    size: PropTypes.oneOf(logoSizeList),
    svg: PropTypes.func,
    verticalAlign: PropTypes.oneOf(verticalAlignList),
  };
}

export default Logo;
